<template>
  <section class="page-container">
    <h1>Newsletter Subscribers</h1>
    <div class="filter-container">
      <div class="flex">
        <div class="filter-box">
          <span class="label">Search</span>
          <div class="search-box">
            <v-input
              v-model="search"
              placeholder="Email"
              @keyEnter="filterData" />
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="email"
          label="Email"></el-table-column>
        <el-table-column
          prop="created_date"
          label="Subscribed Date"></el-table-column>
        <el-table-column
          prop="status_language"
          label="Status"></el-table-column>
        <el-table-column
          label="Action"
        >
          <template #default="{ row }">
            <span
              class="color-primary"
              @click="subsribe(row.status,row.email,row)"
            >{{row.status==0?'Resubscribe':' Unsubscribe'}}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import { getNesLetterList,unsubscribe,resubscribe } from '@/api/newsletter'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'Partnership',
  mixins: [MixinOptions],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      search: '',
      tableData: []
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        let {news={}} =  this.selectFilterData||{}
        Object.keys(news).forEach(item=>{
          this[item] = news[item]
        })
        this.setFilterData(news||{})
        this.network().getNesLetterList()
      }
    }
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    rowClick(row) {
      let params = {
        pageConfig:this.pageConfig,
        search: this.search,
      }
      this.setFilterData({news:params})
      this.$router.push({
        path: '/administration/partnership/detail',
        query: {
          partnership_id: row.id
        }
      })
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getNesLetterList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getNesLetterList()
    },
    subsribe(status,email,row){

      let index = this.tableData.indexOf(row)
      // console.log('index=---0',index)
      // return
      status==0?this.network().resubscribe(email):this.network().unsubscribe(email)


      if(status==0){
        this.tableData[index].status=1
        this.tableData[index].status_language='Subscribed'
      }else{
        this.tableData[index].status=0
        this.tableData[index].status_language='Unsubscribed'
      }


    },
    network() {
      return {
        getNesLetterList: async () => {
          const { data } = await getNesLetterList({
            search: this.search,
            page: this.pageConfig.currentPage
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        resubscribe: async (params) => {
          const { data } = await resubscribe({
            email: params,
          })
          if(data.code==1000)
            this.$message({
              type:'success',
              message:data.message
            })
        },
        unsubscribe: async (params) => {
          const { data } = await unsubscribe({
            email: params,
          })
          if(data.code==1000)
            this.$message({
              type:'success',
              message:data.message
            })
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
 .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 400;
          font-weight: 500;
        }
      }
      .search-box {
          margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }
  }
}
</style>
